<template>

	<div class="file-drag" @dragover="dragover" @dragleave="dragleave" @drop="drop" :style="{height: $attrs.input.attr.height || 'auto'}">

		<input style="display: none" type="file" id="assetsFieldHandle" @change="onChange" ref="input" :accept="$attrs.input.attr.accept" />
	
		<label for="assetsFieldHandle" class="file-drag-content">
			<i class="el-icon-download"></i>
			<p><b>Elige un archivo</b> o arrástralo aquí</p>
		</label>
		<div class="file-drag-files" v-if="model" v-cloak>
			<p>{{ model.name }}</p>
			<el-button @click="remove()" circle size="small" type="default" icon="el-icon-delete" title="Eliminar archivo"></el-button>
		</div>
		
	</div>

</template>

<script>
import {mapState} from 'vuex'

export default {
	name: 'InputSigarusFileDrag',
	props: {
		value: {
			default: ''
		}
	},
	computed: {
		
		...mapState({
			share: state => state.share.data
		}),
		
		model: {

			get () { return this.value },

			set (val) {
				this.$emit('input', val)
			}

		}
	},
	watch: {
		model() {
			if(this.model == "") {
				this.$refs.input.value = ""
			}
		},
		share() {
			if(this.share) this.convertToBase64(this.share)
		}
	},
	mounted() {
		if(this.share) this.convertToBase64(this.share)
	},
	methods: {

		uploadFile() {
			this.$refs.input.value = ''
			this.$refs.input.click()
		},

		handleFile(e) {

			// Comprobar formato disponible
			this.convertToBase64(this.$refs.input.files[0])
			
		},
		async convertToBase64(input_file) {

			console.log('convertToBase64', input_file)

			let {file,base64} = await this.toBase64(input_file)
			
			this.model = {file, base64, name: file.name}

			this.$emit('save') 
		},

		$render(val) {

			return val.name || ''
		},

		toBase64 (file) {
			
			return new Promise((resolve,reject) => {
				var reader = new FileReader()
				reader.readAsDataURL(file)

				reader.onload = function () {
					resolve({file, base64: reader.result})
				}

				reader.onerror = function (error) {
					console.log('Error: ', error)
				}
			})
		},

		// Validar formato
		validFormatFile() {

			let check = true
	
			if(this.$attrs.input.attr.accept) {

				let formatosDisponibles = this.$attrs.input.attr.accept.split(',')
	
				if (!formatosDisponibles.includes(this.$refs.input.files[0].type)) {
					this.$notify.error({
						title: 'Error',
						message: 'Formato de archivo no aceptado'
					});

					check = false
				}
			}

			return check
		},

		// DRAG AND DROP
		async onChange() {

			if(!this.validFormatFile()) return

			let {file,base64} = await this.toBase64(this.$refs.input.files[0]);
			this.model = {file, base64, name: file.name}
			this.$emit('save')
		},
		remove() {
			this.model = '';
		},
		dragover(event) {
			event.preventDefault();
			// Add some visual fluff to show the user can drop its files
			if (!event.currentTarget.classList.contains('ondrag')) {
				event.currentTarget.classList.add('ondrag');
			}
		},
		dragleave(event) {
			// Clean up
			event.currentTarget.classList.remove('ondrag');
		},
		drop(event) {
			event.preventDefault();
			
			this.$refs.input.files = event.dataTransfer.files;
			this.onChange(); // Trigger the onChange event manually
			// Clean up
			event.currentTarget.classList.remove('ondrag');
		}
	}
}
</script>

<style lang="scss">
	.file-drag {
		display: flex;
		flex-flow: column;
		&.ondrag {
			> label.file-drag-content {
				background-color: #ecf5ff;
				border: 1px dashed #409EFF;
			}
		}
		> label.file-drag-content {
			display: flex;
			flex-flow: column;
			align-items: center;
			margin: 0.9rem 0.5rem;
			border: 1px dashed #ebeef5;
			border-radius: 10px;
			padding: 1rem!important;
			background-color: #ebeef50d;
			height: auto!important;
			flex-grow: 1;
			justify-content: center;
			cursor:pointer;
			> i {
				font-size: 2.5rem;
				color: #0000001f;
				margin-bottom: 0.5rem;
			}
			> p {
				margin: 0px;
				text-align: center;
			}
		}
		.file-drag-files {
			margin: 0rem 0.5rem 0.5rem;
			display: flex;
    		align-items: center;
			> p {
				flex-grow: 1;
				margin: 0px 0.5rem 0 0;
				text-overflow: ellipsis;
				word-break: break-word;
				white-space: nowrap;
				overflow: hidden;
				font-size: 0.8rem;
			}
			> button {
				flex-shrink: 0;
			}
		}
	}
</style>
